import './App.css';
import './slider.css';
import { useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {

  function makeAnimationDivWidthOverflowHidden() {
    const _loop_slider_list = document.getElementsByClassName("loop-slider");
    const loopSliderContainerList = document.getElementsByClassName("loop-slider-container");
    if (_loop_slider_list && loopSliderContainerList) {
      console.log("ffff: ", loopSliderContainerList[0].scrollWidth
      // ,loopSliderContainerList[1].scrollWidth
      );
      for (let g = 0; g < _loop_slider_list.length; g++) {
        const loopSliderDiv = _loop_slider_list[g];
        const loopSliderContainerDiv = loopSliderContainerList[g];
        // Check if the targetDiv has a parent with class name "loop-slider-parent"
        if (!loopSliderDiv.parentElement.classList.contains('loop-slider-parent')) {
          
          if(loopSliderContainerDiv){
            loopSliderContainerDiv.style.display = "grid";
            // loopSliderContainerDiv.style.maxWidth = "fit-content";
            // loopSliderContainerDiv.style.position = "absolute";
            // loopSliderContainerDiv.style.width = (loopSliderContainerDiv.parentElement.scrollWidth - 3) + "px";
            let loopSliderParent = document.createElement('div');
            loopSliderParent.style.overflow = "hidden";
            // loopSliderParent.classList.add('loop-slider-parent');
            loopSliderContainerDiv.appendChild(loopSliderParent);
            loopSliderParent.appendChild(loopSliderDiv);
          }
        }
      }
  
  
      for (let h = 0; h < _loop_slider_list.length; h++) {
        const loopSliderDiv = _loop_slider_list[h];
        const loopSliderContainerDiv = loopSliderContainerList[h];
        // Check if the targetDiv has a parent with class name "loop-slider-parent"
        if (!loopSliderDiv.parentElement.classList.contains('loop-slider-parent')) {
          if(loopSliderContainerDiv){
            loopSliderContainerDiv.firstElementChild.classList.add('loop-slider-parent');
            // loopSliderContainerDiv.style.width = (loopSliderContainerDiv.parentElement.scrollWidth - 3) + "px";
          }
        }
      }
  
  
    }
  }

  function loopSliderAnimationFunc() {

    // this is to get rid of horizontal bar or to make animation div's width independent of parent div's width.
    makeAnimationDivWidthOverflowHidden();
  
  
    const _loop_slider_list = document.getElementsByClassName("loop-slider");
  
    if (_loop_slider_list) {
      for (let i = 0; i < _loop_slider_list.length; i++) {
        const isAnimAlreadyRunning =
          _loop_slider_list[i].getAttribute("is-running");
        if(!isAnimAlreadyRunning){
          let sliderDuration = 15000; // default duration in 15000ms
          const speedAttr = _loop_slider_list[i].getAttribute("speed") || null;
          const alignAttr = _loop_slider_list[i].getAttribute("align") || "left";
          const directionAttr = _loop_slider_list[i].getAttribute("direction");
          const pauseTimeAttr =
            parseInt(_loop_slider_list[i].getAttribute("pause-time")) || null;
          const playTimeAttr =
            parseInt(_loop_slider_list[i].getAttribute("play-time")) || null;
          const pauseOnHover =
            _loop_slider_list[i].getAttribute("pause-on-hover") || null;
          const sliderInnerElem =
            _loop_slider_list[i].getElementsByClassName("loop-slider-inner")[0];
          // default direction is normal, mean rtl
          const sliderDirection = directionAttr === "ltr" ? "reverse" : "normal";
          if (sliderInnerElem) {
            _loop_slider_list[i].setAttribute("is-running", true);
  
  
            // double or (duplicate all child and add in same parent element)
            const sliderInnerElemChildren = sliderInnerElem.children;
            const clonedChildElements = [];
            if (sliderInnerElemChildren) {
              // Loop through all child elements
              for (let j = 0; j < sliderInnerElemChildren.length; j++) {
                const clonedSliderInnerElemChild =
                  sliderInnerElemChildren[j].cloneNode(true);
                clonedChildElements.push(clonedSliderInnerElemChild);
              }
              // append each cloned chlid element
              clonedChildElements.forEach(function (currentClonedElement) {
                sliderInnerElem.appendChild(currentClonedElement);
              });
  
              // below code is to show 50% animation block and in center the animation block to maintain continuous visibility
              if(alignAttr==="center"){
                const halfWidth = parseInt((sliderInnerElem.scrollWidth/2)-2);
                _loop_slider_list[i].style.width = halfWidth + "px";
                _loop_slider_list[i].style.marginLeft = "auto";
                _loop_slider_list[i].style.marginRight = "auto";
              }
              
              // 5 is the default speed
              const _speed =
                parseFloat(speedAttr) && parseFloat(speedAttr) > 0
                  ? parseFloat(speedAttr)
                  : 5;
              sliderDuration = parseInt(
                (sliderInnerElem.scrollWidth * 100) / _speed
              );
              // check both "pauseTimeAttr" and "playTimeAttr" are number and greater than "zero"
              if (
                parseFloat(pauseTimeAttr) &&
                parseFloat(pauseTimeAttr) > 0 &&
                parseFloat(playTimeAttr) &&
                parseFloat(playTimeAttr) > 0
              ) {
                // below code run the animation with steps using pauseTime and playTime
                function runAnimation() {
                  sliderInnerElem.style.animationPlayState = "running";
                  setTimeout(function () {
                    pauseAnimation();
                  }, parseInt(playTimeAttr));
                }
                function pauseAnimation() {
                  sliderInnerElem.style.animationPlayState = "paused";
                  setTimeout(function () {
                    runAnimation();
                  }, parseInt(pauseTimeAttr));
                }
                // run animation with pause-time and play-time "continuously"
                runAnimation();
              }
              _loop_slider_list[i].style.setProperty(
                "--loop_slider_duration",
                sliderDuration + "ms"
              );
              _loop_slider_list[i].style.setProperty(
                "--loop_slider_direction",
                sliderDirection
              );
  
              // display elements after animation starts
              setTimeout(function () {
                _loop_slider_list[i].style.setProperty("opacity", "1");
                _loop_slider_list[i].style.setProperty("transition", "opacity 1s");
              }, 300);
  
              if (pauseOnHover === "true") {
                // pause animation onHover
                _loop_slider_list[i].addEventListener("mouseover", () => {
                  sliderInnerElem.classList.add("loopSliderPauseOnHover");
                });
  
                _loop_slider_list[i].addEventListener("mouseout", () => {
                  sliderInnerElem.classList.remove("loopSliderPauseOnHover");
                });
              }
              // Update the "sliderDuration" whenever the parent element width changes due to the loading
              // of images/elements inside the parent element, as the "sliderDuration" is directly dependent
              // on the parent element's width.
              function handleResize(entries) {
                sliderDuration = parseInt(
                  (sliderInnerElem.scrollWidth * 100) / _speed
                );
                _loop_slider_list[i].style.setProperty(
                  "--loop_slider_duration",
                  sliderDuration + "ms"
                );
              }
              // Create a ResizeObserver with the callback function
              const resizeObserver = new ResizeObserver(handleResize);
              // Start observing the target element
              resizeObserver.observe(sliderInnerElem);
            }
          }
        }
      }
    }
  }

  useEffect(()=>{
    loopSliderAnimationFunc();
  }, []);

  return (
    <div className='mainDiv'>
      {/* <LoopSlider /> */}
      <div className='innerDiv'>
        {/* value of "speed", "pause-time" and "play-time" must be greater than zero
        animation will not pause if "pause-time" and "play-time" are not given, "pause-time" and "play-time" must be in mili-seconds.
        direction="rtl" or direction="ltr"  (default is "rtl" ==> right-to-left)
        must specify any dimension unit with the "--loopSliderGap" variable like "px", "rem", etc.
        default value of "pause-on-hover=" is false
        align="center" is to show animation in center of parent div */}

        {/* <h1>Hot-Slider</h1> */}
        {/* <br/> */}

        <div>

          {/* number slider */}
          <div className="loop-slider-container marginBottomCustom numberSlider">
            <div
              className="loop-slider"
              speed="10"
              direction="rtl"
              style={{ "--loopSliderGap": "20px" }}
            >
              <div className="loop-slider-inner">
                <img src="./img/numberImages/1.jpg" alt="slider" />
                <img src="./img/numberImages/2.jpg" alt="slider" />
                <img src="./img/numberImages/3.jpg" alt="slider" />
                <img src="./img/numberImages/4.jpg" alt="slider" />
                <img src="./img/numberImages/1.jpg" alt="slider" />
                <img src="./img/numberImages/2.jpg" alt="slider" />
                <img src="./img/numberImages/3.jpg" alt="slider" />
                <img src="./img/numberImages/4.jpg" alt="slider" />
              </div>
            </div>
          </div>
          {/* roman numbers */}
          <div className="loop-slider-container marginBottomCustom numberSlider">
            <div
              className="loop-slider"
              speed="20"
              direction="rtl"
              pause-time="500"
              play-time="500"
              style={{ "--loopSliderGap": "20px" }}
            >
              <div className="loop-slider-inner">
                <img src="./img/romanImages/1.jpg" alt="slider" />
                <img src="./img/romanImages/2.jpg" alt="slider" />
                <img src="./img/romanImages/3.jpg" alt="slider" />
                <img src="./img/romanImages/4.jpg" alt="slider" />
                <img src="./img/romanImages/1.jpg" alt="slider" />
                <img src="./img/romanImages/2.jpg" alt="slider" />
                <img src="./img/romanImages/3.jpg" alt="slider" />
                <img src="./img/romanImages/4.jpg" alt="slider" />
              </div>
            </div>
          </div>

          

          <div className='d-flex justify-content-between arrowIcons cardMain marginBottomCustom'>
            {/*first cards */}
            <div
              className="card text-white bg-dark cardContainer"
            >
              <div className="card-body">
                <h5 className="card-title">Left to right</h5>
                <p className="card-text">
                  Lorem ipsum dolor sit amet, consectetu.
                </p>
                {/* sliding content */}
                <div className="loop-slider-container">
                  <div
                    className="loop-slider"
                    speed="5"
                    direction="ltr"
                    // align="center"
                    style={{ "--loopSliderGap": "40px" }}
                  >
                    <div className="loop-slider-inner">
                      <img src="./img/arrow/right.png" alt="slider" />
                      <img src="./img/arrow/right.png" alt="slider" />
                      <img src="./img/arrow/right.png" alt="slider" />
                      <img src="./img/arrow/right.png" alt="slider" />
                      <img src="./img/arrow/right.png" alt="slider" />
                      <img src="./img/arrow/right.png" alt="slider" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/*second cards */}
            <div
              className="card text-white bg-dark cardContainer"
            >
              <div className="card-body">
                <h5 className="card-title">Right to left</h5>
                <p className="card-text">
                  Aut ipsam repellendus et nobis commodi.
                </p>
                {/* sliding content */}
                <div className="loop-slider-container">
                  <div
                    className="loop-slider"
                    speed="5"
                    direction="rtl"
                    // align="center"
                    style={{ "--loopSliderGap": "40px" }}
                  >
                    <div className="loop-slider-inner">
                      <img src="./img/arrow/left.png" alt="slider" />
                      <img src="./img/arrow/left.png" alt="slider" />
                      <img src="./img/arrow/left.png" alt="slider" />
                      <img src="./img/arrow/left.png" alt="slider" />
                      <img src="./img/arrow/left.png" alt="slider" />
                      <img src="./img/arrow/left.png" alt="slider" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="loop-slider-container promotionIcons">
            <div
              className="loop-slider"
              speed="13.8"
              direction="ltr"
              style={{ "--loopSliderGap": "20px" }}
            >
              <div className="loop-slider-inner">
                <img
                  src="./img/promotionIcons/1.png"
                  alt="slider"
                />
                <img
                  src="./img/promotionIcons/2.png"
                  alt="slider"
                />
                <img
                  src="./img/promotionIcons/3.png"
                  alt="slider"
                />
                <img
                  src="./img/promotionIcons/4.png"
                  alt="slider"
                />
                <img
                  src="./img/promotionIcons/5.png"
                  alt="slider"
                />
                <img
                  src="./img/promotionIcons/6.png"
                  alt="slider"
                />
                <img
                  src="./img/promotionIcons/1.png"
                  alt="slider"
                />
                <img
                  src="./img/promotionIcons/2.png"
                  alt="slider"
                />
                <img
                  src="./img/promotionIcons/3.png"
                  alt="slider"
                />
                <img
                  src="./img/promotionIcons/4.png"
                  alt="slider"
                />
                <img
                  src="./img/promotionIcons/5.png"
                  alt="slider"
                />
                <img
                  src="./img/promotionIcons/6.png"
                  alt="slider"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
